module.exports = __webpack_public_path__ + "img/form-a11y-2.0fd93ba3.png";